import React from 'react';
import { colors } from '../../config/theme';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(theme => ({
  dropBoxContainer: {
    height: '280px',
    width: '100%',
    // opacity: '0.7',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  childContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  connectionLostIcon: {
    width: '64px',
    height: '64px'
  },
  header: {
    fontSize: '20px',
    fontWeight: '500',
    color: colors.black
  },
  description: {
    color: colors.gray,
    lineHeight: '1.6px',
    fontSize: '16px'
  },
  button: {
    marginTop: '64px',
    marginBottom: '0'
  }
}));

export default useStyles;
